module.exports = __webpack_public_path__ + "static/commlab-ade8b1ce9157e0ca27955ddf85e69299.svg";